export default "__VITE_ASSET__UVYQbwzd__"